import * as z from "zod";

export const getUpsellMetricsSummary = {
  name: "getUpsellMetricsSummary" as const,
  input: z.object({ startDate: z.date(), endDate: z.date() }),
  output: z.object({
    totalRevenue: z.number(),
    totalVisits: z.number(),
    totalAcceptedOffers: z.number(),
    totalConversionRate: z.number(),
    totalRevenuePerVisit: z.number(),
  }),
};
export type GetUpsellMetricsSummaryOutput = z.infer<
  typeof getUpsellMetricsSummary.output
>;
